module.exports = __webpack_public_path__ + "img/venus31.217583e5.png";